import styled from "styled-components";

const Notice = styled.aside`
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 8px;
  color: #664d03;
  line-height: 1.5;
  margin: 20px 0;
  padding: 16px;

  p {
    margin: 8px 0 0;
  }
`;

export function CoursePaymentNotice({ stage = "before" }: { stage?: "before" | "pending" | "recap" }) {
  const instructions = {
    before: "Dopo aver inviato l'iscrizione sulla piattaforma CO2, troverai i collegamenti per inserire i nomi dei partecipanti e completare l'iscrizione e il pagamento sul sito della Scuola Sci Maestri Pinzolo.",
    pending: "L'iscrizione è stata inviata sulla piattaforma CO2. Per completare l'iscrizione e il pagamento, usa il pulsante qui sotto e inserisci il nome dell'iscritto sul sito della Scuola Sci Maestri Pinzolo.",
    recap: "L'iscrizione è stata inviata sulla piattaforma CO2. Per completare l'iscrizione e il pagamento, usa il pulsante di ogni iscritto in attesa qui sotto e inserisci il suo nome sul sito della Scuola Sci Maestri Pinzolo.",
  };

  return (
    <Notice>
      <strong>COME COMPLETARE L'ISCRIZIONE</strong>
      <p>{instructions[stage]}</p>
      <p>
        <strong>La sola iscrizione sulla piattaforma CO2, senza il pagamento sul sito della scuola, non è un'iscrizione valida.</strong>{" "}
        CO2 confermerà il corso solo dopo aver verificato il pagamento.
      </p>
    </Notice>
  );
}
